'use client';

import { Skeleton } from '@mui/material';
import { HousingCardSkeleton } from '@/components';
import { Container, Wrapper } from '@/features/pages/home';
import { CenteredHead, GridList } from './styled';

export const DiscountedSkeleton = () => (
  <Wrapper $bgColor="blue">
    <Container>
      <CenteredHead>
        <Skeleton
          variant="text"
          width={300}
          height={40}
          sx={{ bgcolor: 'rgba(255,255,255,0.15)' }}
        />
        <Skeleton
          variant="text"
          width={420}
          height={24}
          sx={{ bgcolor: 'rgba(255,255,255,0.1)' }}
        />
      </CenteredHead>
      <GridList>
        {Array.from({ length: 3 }).map((_, i) => (
          <HousingCardSkeleton key={i} />
        ))}
      </GridList>
    </Container>
  </Wrapper>
);
